export function BackgroundPattern() {
  return (
    <div className="background-pattern">
      {/* Ambient Gradient Orbs matching VoxArro Purple/Blue Theme */}
      <div className="ambient-mesh ambient-purple" />
      <div className="ambient-mesh ambient-indigo" />
      <div className="ambient-mesh ambient-cyan" />
      
      {/* Subtle Dot Grid */}
      <div className="grid-overlay" />
    </div>
  );
}

